// @ts-ignore
import { createHash } from 'sha256-uint8array/dist/sha256-uint8array.min.js';
export function sss(input) {
    return createHash().update(input).digest('hex');
}
function sha256buf(input) {
    return createHash().update(input).digest();
}
function fromString(input) {
    const encoder = new TextEncoder();
    return encoder.encode(input);
}
function fromBuffer(buf) {
    const decoder = new TextDecoder('utf8');
    return decoder.decode(buf);
}
function H(x, y, ret) {
    const buflen = x.length + y.length;
    const buf = new Uint8Array(buflen);
    buf.set(x, 0);
    buf.set(y, x.length);
    // TODO: throw error if outsize bounds
    ret.set(sha256buf(buf));
}
const SHA256_HASH_SIZE = 256 / 8;
const SHA256_BLOCK_SIZE = 64;
const hex8 = (num) => (num + 0x100000000).toString(16).slice(-2);
function hssss(_key, _data) {
    const key = fromString(_key);
    const data = fromString(_data);
    const k = new Uint8Array(SHA256_BLOCK_SIZE);
    const k_ipad = new Uint8Array(SHA256_BLOCK_SIZE);
    const k_opad = new Uint8Array(SHA256_BLOCK_SIZE);
    const ihash = new Uint8Array(SHA256_HASH_SIZE);
    const ohash = new Uint8Array(SHA256_HASH_SIZE);
    k.fill(0);
    k_ipad.fill(0x36);
    k_opad.fill(0x5c);
    if (key.length > SHA256_BLOCK_SIZE) {
        k.set(sha256buf(key));
    }
    else {
        k.set(key);
    }
    for (let i = 0; i < SHA256_BLOCK_SIZE; i++) {
        k_ipad[i] ^= k[i];
        k_opad[i] ^= k[i];
    }
    // Perform HMAC algorithm: ( https://tools.ietf.org/html/rfc2104 )
    //      `H(K XOR opad, H(K XOR ipad, data))`
    H(k_ipad, data, ihash);
    H(k_opad, ihash, ohash);
    const ret = new Uint8Array(ohash.length * 2);
    for (let i = 0; i < ohash.length; i++) {
        const str = hex8(ohash[i]);
        ret[i * 2] = str.charCodeAt(0);
        ret[i * 2 + 1] = str.charCodeAt(1);
    }
    return fromBuffer(ret);
}
export function toBoxedValue(vm, target, value, deep = 5) {
    if (deep <= 0) {
        return vm.createNull();
    }
    if (value === undefined) {
        return vm.createUndefined();
    }
    else if (value === null) {
        return vm.createNull();
    }
    else if (typeof value === "boolean") {
        return vm.createBoolean(value);
    }
    else if (typeof value === "number") {
        return vm.createNumber(value);
    }
    else if (typeof value === "string") {
        return vm.createString(value);
    }
    else if (typeof value === "object") {
        const vTarget = "length" in value ? vm.createArray() : vm.createObject();
        vTarget.value.value = value;
        for (let key in value) {
            if (!(key === "self"
                || key === "alert"
                || key === "print"
                || key === "console"
                || key === "parent"
                || key === "frames"
                || key === "window"
                || key === "document"
                || key === "setTimeout"
                || key === "setInterval"
                || key === "clearTimeout"
                || key === "clearInterval"
                || key === "localStorage"
                || key === "AudioContext"
                || key === "webkitAudioContext"
                || key === "OfflineAudioContext"
                || key === "webkitOfflineAudioContext"
            // || value[key] instanceof Node
            )) {
                try {
                    vm.setProperty(vTarget, key, toBoxedValue(vm, value, value[key], deep - 1));
                }
                catch (e) {
                    // nothing to do, just move on...
                }
            }
        }
        return vTarget;
    }
    else if (typeof value === "function") {
        return vm.createFunction("anonymous", function () {
            const args = [];
            for (let i = 0, length = arguments.length; i < length; i++) {
                const item = arguments[i];
                if (vm.isUndefined(item)) {
                    args.push(undefined);
                }
                else if (vm.isNull(item)) {
                    args.push(null);
                }
                else if (vm.isBoolean(item)) {
                    args.push(vm.asBoolean(item));
                }
                else if (vm.isNumber(item)) {
                    args.push(vm.asNumber(item));
                }
                else if (vm.isString(item)) {
                    args.push(vm.asString(item));
                }
            }
            try {
                return toBoxedValue(vm, target, value.apply(target, args));
            }
            catch (e) {
                vm.throw(vm.createError(`${e.message} ${e.stack}`));
            }
        });
    }
    else {
        return vm.createUndefined();
    }
}
const _G = typeof window === 'undefined' ? globalThis : window;
function __global(vm) {
    const global = vm.getGlobal();
    const vG = vm.createObject();
    const gKeys = [];
    for (let key in _G) {
        gKeys.push(key);
        vm.defineProperty(vG, key, {
            enumerable: true,
            get: vm.createFunction(key, function () {
                const value = _G[key];
                return toBoxedValue(vm, _G, value);
            }),
        });
    }
    const vSetTimeout = vm.createFunction("setTimeout", function (vHandler, vTimeout) {
        const timeout = vm.isNumber(vTimeout) ? vm.asNumber(vTimeout) : 0;
        let handler = () => { };
        if (vm.isFunction(vHandler)) {
            handler = function () {
                vm.call(vHandler);
            };
        }
        const timer = setTimeout(handler, timeout);
        return vm.createNumber(timer);
    });
    const vSetInterval = vm.createFunction("setInterval", function (vHandler, vInterval) {
        const interval = vm.isNumber(vInterval) ? vm.asNumber(vInterval) : 0;
        let handler = () => { };
        if (vm.isFunction(vHandler)) {
            handler = function () {
                vm.call(vHandler);
            };
        }
        const timer = setInterval(handler, interval);
        return vm.createNumber(timer);
    });
    const vClearTimeout = vm.createFunction("clearTimeout", function (vTimer) {
        clearTimeout(vm.asNumber(vTimer));
        return vm.createUndefined();
    });
    const vClearInterval = vm.createFunction("clearInterval", function (vTimer) {
        clearInterval(vm.asNumber(vTimer));
        return vm.createUndefined();
    });
    const vConsole = vm.createObject();
    const conKeys = [];
    for (let key in console) {
        conKeys.push(key);
        vm.defineProperty(vConsole, key, {
            enumerable: true,
            get: vm.createFunction(key, function () {
                const value = console[key];
                return toBoxedValue(vm, console, value);
            }),
        });
    }
    vm.setProperty(global, "setTimeout", vSetTimeout);
    vm.setProperty(global, "setInterval", vSetInterval);
    vm.setProperty(global, "clearTimeout", vClearTimeout);
    vm.setProperty(global, "clearInterval", vClearInterval);
    vm.setProperty(global, "globalThis", vG);
    vm.setProperty(global, "console", vConsole);
    const vModule = vm.createObject();
    vm.setProperty(global, "module", vModule);
}
function __encrypt(vm) {
    const vGlobal = vm.getGlobal();
    vm.setProperty(vGlobal, 'sss', vm.createFunction('sss', function (input) {
        return vm.createString(sss(vm.asString(input)));
    }));
    vm.setProperty(vGlobal, 'hssss', vm.createFunction('hssss', function (key, data) {
        return vm.createString(hssss(vm.asString(key), vm.asString(data)));
    }));
    let ggnStr = false;
    vm.setProperty(vGlobal, 'ggn', vm.createFunction('ggn', function (key, data) {
        var _a;
        if (ggnStr === false) {
            ggnStr = ((_a = globalThis === null || globalThis === void 0 ? void 0 : globalThis.__ggn) === null || _a === void 0 ? void 0 : _a.call(globalThis)) || '';
            delete globalThis.__ggn;
        }
        // at almost, __ggn is for test environment
        return vm.createString(ggnStr);
    }));
    return vGlobal;
}
export const bindings = (vm) => {
    __global(vm);
    const vGlobal = __encrypt(vm);
    /* assume vm has run source code */
    const getExports = (vm) => {
        const vMod = vm.getProperty(vGlobal, 'module');
        const vExports = vm.getProperty(vMod, 'exports');
        return vExports;
    };
    return {
        vGlobal,
        getExports
    };
};
